import { Button } from "@circleco/compass/components/Button";
import { Tabs } from "@circleco/compass/components/Tabs";
import isFunction from "lodash/isFunction";

import { t } from "@/i18n-js/instance";

import { useEmojiPickerV4Context } from "./EmojiPickerV4Context";

interface EmojiPickerV4TabsProps {
  dismiss: () => void;
}

export const EmojiPickerV4Tabs = ({ dismiss }: EmojiPickerV4TabsProps) => {
  const { enabledTabs, activeTab, setActiveTab, onRemoveEmoji } =
    useEmojiPickerV4Context();

  const canRemove = isFunction(onRemoveEmoji);
  if (enabledTabs.length < 2 && !canRemove) return null;

  const tabs = enabledTabs.map(tab => ({
    label: t(tab.labelKey),
    value: tab.id,
  }));

  return (
    <div className="flex items-center justify-between gap-2">
      <Tabs.Root
        tabs={tabs}
        selectedValue={activeTab.id}
        onValueChange={value => {
          const next = enabledTabs.find(item => item.id === value);
          if (next) setActiveTab(next);
        }}
      />
      {canRemove && (
        <Button
          variant="outline"
          size="sm"
          type="button"
          onClick={() => {
            onRemoveEmoji?.();
            dismiss();
          }}
        >
          {t("emoji_picker_v4.remove")}
        </Button>
      )}
    </div>
  );
};
